import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface UpsellWizardGenericStepProps {
  featureRequested: Features
  requestSource: string
}

export const UpsellWizardGenericStep = ({
  featureRequested,
  requestSource,
}: UpsellWizardGenericStepProps) => {
  return (
    <Box flexDirection="column" gap="s24" width="s400">
      <Box
        padding="s24"
        gap="s24"
        justifyContent="center"
        alignItems="center"
        borderRadius={{ all: 'abs008' }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        background="grey000White"
      >
        <UpsellingKit.EmptyState
          moduleRequested={AvailableModules.projects}
          featureRequested={featureRequested}
          requestReason={ValidReasons.MissingFeature}
          requestSource={requestSource}
          title={i18n.t('project_management.upselling.title')}
          description={i18n.t('project_management.upselling.settings')}
          buttonLabel={i18n.t('project_management.upselling.cta')}
          variant="card"
        />
      </Box>
    </Box>
  )
}
